import type {UntypedPayload} from 'constants/events/EventPayloadUtils';
import type {Request} from 'requests/RequestConstants';

interface CalendarRequestsFetchResponse {
  [dateString: string]: Array<Request>;
}

export const CALENDAR_EVENT_PAYLOADS = {
  CALENDAR_CLOSE_CREATE_POPOVER: {} as UntypedPayload,
  CALENDAR_DATE_NAVIGATE: {} as UntypedPayload,
  CALENDAR_DAY_MOUSE_DOWN: {} as UntypedPayload,
  CALENDAR_DAY_MOUSE_OVER: {} as UntypedPayload,
  CALENDAR_DAY_MOUSE_UP: {} as UntypedPayload,
  CALENDAR_ENTRIES_FETCH: {} as UntypedPayload,
  CALENDAR_ENTRIES_FETCH_COMPLETED: {} as UntypedPayload,
  CALENDAR_ENTRIES_FETCH_FAILED: {} as UntypedPayload,
  CALENDAR_FILES_FETCH: {} as UntypedPayload,
  CALENDAR_FILES_FETCH_COMPLETED: {} as UntypedPayload,
  CALENDAR_FILES_FETCH_FAILED: {} as UntypedPayload,
  CALENDAR_REQUESTS_FETCH: {} as {},
  CALENDAR_REQUESTS_FETCH_COMPLETED: {} as {
    requests: CalendarRequestsFetchResponse;
  },
  CALENDAR_REQUESTS_FETCH_FAILED: {} as {},
  CALENDAR_ITEM_DESELECTED: {} as UntypedPayload,
  CALENDAR_ITEM_SELECTED: {} as UntypedPayload,
  CALENDAR_TOGGLE_PROJECT_HIDDEN: {} as UntypedPayload,
  CALENDAR_UPDATE_ENTRY_TASK: {} as UntypedPayload,
  CALENDAR_UPDATE_FILTERED_MEMBERS: {} as UntypedPayload,
  CALENDAR_UPDATE_TODAY: {} as UntypedPayload,
  CALENDAR_VIEW_CHANGE: {} as UntypedPayload,
} as const;

export type CalendarEventPayload = typeof CALENDAR_EVENT_PAYLOADS;
